import axiosInstance from "../config/API";

const API_ENDPOINT = "/expense_category.php";

// Fetch all categories
export const fetchCategoriesApi = async (searchText = "") => {
  const payload = {
    action: "listCategories",
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head, body } = response.data;
  console.log(response.data);
  if (head.code !== 200) {
    throw new Error(head.msg);
  }

  return body.Categories;
};

// Add a new category
export const addCategoryApi = async (categoryData) => {
  const payload = {
    action: "addCategory",
    category_name: categoryData.category_name,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head, body } = response.data;

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to create category");
  }

  return body.Categories[0]; // Return the newly created category
};

// Update a category
export const updateCategoryApi = async (categoryData) => {
  const payload = {
    action: "updateCategory",
    category_id: categoryData.category_id,
    category_name: categoryData.category_name,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head } = response.data;

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to update category");
  }

  return { category_id: head.id, ...categoryData }; // Return the updated category data
};

// Delete a category
export const deleteCategoryApi = async (categoryId) => {
  const payload = {
    action: "deleteCategory",
    delete_category_id: categoryId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head } = response.data;

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to delete category");
  }

  return categoryId; // Return the deleted category ID
};
